import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
  EnvironmentProviders,
  importProvidersFrom,
  inject,
  provideEnvironmentInitializer,
  Provider,
} from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { BaseConfig } from '@base/services/config';
import { BASE_CONFIG } from '@base/services/config/config.constants';
import { ConfirmationService } from '@base/services/confirmation';
import { loadingInterceptor, LoadingService } from '@base/services/loading';
import { MediaWatcherService } from '@base/services/media-watcher';
import { PlatformService } from '@base/services/platform';
import { SplashScreenService } from '@base/services/splash-screen';
import { UtilsService } from './services/utils';

export type BaseProviderConfig = {
  base?: BaseConfig;
};

/**
 *  provider
 */
export const provideBase = (config: BaseProviderConfig): Array<Provider | EnvironmentProviders> => {
  // Base providers
  const providers: Array<Provider | EnvironmentProviders> = [
    {
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'outline',
      },
    },
    {
      provide: BASE_CONFIG,
      useValue: config?.base ?? {},
    },

    importProvidersFrom(MatDialogModule),
    provideEnvironmentInitializer(() => inject(ConfirmationService)),

    provideHttpClient(withInterceptors([loadingInterceptor])),
    provideEnvironmentInitializer(() => inject(LoadingService)),

    provideEnvironmentInitializer(() => inject(MediaWatcherService)),
    provideEnvironmentInitializer(() => inject(PlatformService)),
    provideEnvironmentInitializer(() => inject(SplashScreenService)),
    provideEnvironmentInitializer(() => inject(UtilsService)),
  ];

  // Return the providers
  return providers;
};
